/* eslint-disable */

import { observable, computed, observe } from 'mobx';
import { store } from '../stores/mainStore';
import { integration } from '../integration';
import { history } from '../history';
import {createHandName} from './scoreCardElements';

export class Manager {
	constructor() {
		console.log('new manager', this);
		this.music = null;
		this.init();
		console.log('MANAGER INIT');
	}

	init = () => {
		if (this.sceneRestarting === true) return;

		this.config = null;
		this.game = null;
		this.scene = null;
		this.createScene = null;

		this.diceHand = null;
		this.cup = null;
		this.handHelp = null;
		this.skipTutorial = null;

		this.gameHudLevelText = null;
		this.handPointerTimer = null;
		this.cupSwirlTimer = null;
		this.cupDragAutoFireTimer = null;
		this.cupNoticeMeTimer = null;
		this.rollBannerTimer = null;

		this.assetURL = '/assets';
		this.scoreCardElements = [];
		this.scoreCardHands = [];
		this.scoreCardOpponentHands = [];
		this.scoreCardBrownCirclePointsHands = [];
		this.scoreCardBrownCirclePointsOpponentHands = [];
		this.gamesStarted = 0;
		this.pushDownAmount = 12;
		this.pinkHeart = null;
		this.heartText = null;
		this.heartArea = null;
		this.text = null;
		this.rollInfo = null;
		this.handText = null;
		this.arrow = null;
		this.readyToLaunch = false;
		this.observer1 = null;
		this.observer2 = null;
		this.observer3 = null;
		this.soundObserver = null;
		this.diceTinyScale = 0.1 * 2;// * (128/256);

		this.hands = {
			1:		'high-hand'       ,
			2:		'pair'            ,
			3:		'two-pair'        ,
			4:		'three-of-a-kind' ,
			5:		'straight'        ,
			6:		'flush'           ,
			7:		'full-house'      ,
			8:		'four-of-a-kind'  ,
			9:		'five-of-a-kind'  ,
			10:		'six-of-a-kind'   ,
			11:		'straight-flush'  ,
			12:		'royal-flush',
			21:		'three-pair',
			22:		'four-pair',
			31:		'three-straight',
			32:		'four-straight',
			41:		'big-house',
			42:		'two-three-of-a-kind',
			51:		'three-straight-flush',
			52:		'four-straight-flush',
			61:		'all-black',
			62:		'all-red',
			63:		'five-flush-diamonds',
			64:		'five-flush-hearts',
			65:		'five-flush-spades',
			66:		'five-flush-clubs'
		};
		
		this.handBannerHandNames = ["blank",
			'three-straight-flush',
			'two-pair',
			'three-of-a-kind',
			'four-straight',
			'straight',
			'flush',
			'full-house',
			'three-pair',
			'five-flush-clubs',
			'five-flush-spades',
			'five-flush-hearts',
			'five-flush-diamonds',
			'two-three-of-a-kind',
			'all-red',
			'all-black',
			'four-straight-flush',
			'four-of-a-kind',
			'straight-flush',
			'royal-flush',
			'highest-hand'
		];
	   //this.dicePerHandType = [0, 3, 4, 3, 4, 5, 5, 5, 6, 5, 5, 5, 5, 6, 9, 9, 4, 4, 5, 5, 9];
	   this.dicePerHandType = [0, 3, 4, 3, 4, 5, 5, 5, 6, 5, 5, 5, 5, 6, 5, 5, 4, 4, 5, 5, 9];

		this.scoreCardContainer = null;
		this.scoreCardBkg = null;
		this.scoreCardHeader = null;
		this.scoreCardFooter = null;
		this.scoreCardFooterOverlay = null;
		this.bannerContainer = null;
		this.resultsBanner = null;
		this.scoreCardBanner = null;
		this.lowerBonusLeft = null;
		this.lowerBonusRight = null;
		this.upperBonusLeft = null;
		this.upperBonusRight = null;
		this.finalScoreLeft = null;
		this.finalScoreRight = null;
		this.lastScoreLeft = null;
		this.lastScoreRight = null;
		this.turnScoresLeft = [];
		this.turnScoresRight = [];
		this.pLeft = null;
		this.pRight = null;
		this.floatingStars = null;
		this.resultsProfilePic = null;
		this.resultsStarsContainer = null;
		this.opponentResultsStarsContainer = null;
		this.resultsProfileShape = null;
		this.resultsOpponentPic = null;
		this.myMatchName = null;
		this.opponentMatchName = null;
		this.myMatchPic = null;
		this.opponentMatchPic = null;
		this.vs = null;
		this.myLevelStar = null;
		this.opponentLevelStar = null;
		this.myMatchRing = null;
		this.opponentMatchRing = null;
		this.scoreCardTweens = [];
		this.zoomerContainer = null;
		this.avaPanel = null;
		this.lastZoomedDice = 0;
		this.lastZoomerTween = null;
		this.currentHandObserver = null;
		this.diceReceived = false;
		this.matchPanel = null;
		this.matchBlur = null;
		this.goalArrowTween = null;
		this.goalArrowTween2 = null;
		this.handBanner = null;
		this.jackPotText = null;
		this.roundBanner = null;
		this.turnBanner = null;
		this.myTotalScore = 0;
		this.opponentTotalScore = 0;
		this.myLowerBonusScore = 0;
		this.myUpperBonusScore = 0;
		this.opponentLowerBonusScore = 0;
		this.opponentUpperBonusScore = 0;
		this.matchesThisSession = 0;
		this.scorehelp = null;
		this.gameHud = null;
		this.gameHudBackButton = null;
		this.gameHudDropdown = null;
		this.gameState = { state: 'idle' };
		this.diceStatus = 'resolved';
		this.playfield = null;
		this.playfieldFrame = null;
		this.playfieldHighPosition = 0;
		this.playfieldLowPosition = 0;
		this.showCupDebugInfo = false;
		this.playHandButtonPressed = false;
		this.extraRollButtonPressed = false;
		this.levelBeforeDoubleXP = 0;
	};

	updateCustomSkin(type, newValue) {
		if(type === 'handNames') {
			store.custom.handNames = newValue;
			this.handNameInstances.getChildren().forEach(cont => {
				createHandName(cont.config);
			})
		}
		if(type === 'table') {
			if(this.scoreCardBkg)	this.scoreCardBkg.setTexture(newValue + '_gameBkg');
			this.playfield.setTexture(newValue + '_gameBkg');
			this.playfieldFrame.setTexture(newValue + '_playfieldFrame');
			this.playfieldFrame.setScale(this.config.width / this.playfieldFrame.width, this.config.width / this.playfieldFrame.width);
		}
		if(type === 'cup') {
			this.cup.cupSprite.setTexture(newValue + '_cup_sheet', this.cup.cupSprite.frame.name);
		}
		if(type === 'dice') {
			this.diceInstances.getChildren().forEach(spr => {
				const arr = spr.texture.key.split('_')
				if(arr.shift() === store.custom[type]) {
					const textureName = [newValue, ...arr].join('_');
					spr.setTexture(textureName, spr.frame.name);
				}
			})
		}

		if (process.env.NODE_ENV !== 'production') { 
			//## development mode only 
			if(type === 'usePopper' 
				// && !store.isProd 
				&& store.activeMatch.currentHand.rollsRemaining > 0
				&& !store.activeMatch.currentHand.best
				&& !store.showSummary
			) {
				if(newValue) {		// show popper, hide Cup
					this.cup.hideCup();
					this.ui.hideRoundBannerText();
					this.popper.show();
				} else {			// hide popper, show Cup
					this.popper.hide();
					this.cup.reallyFakeReturnCup(false)
					if(store.activeMatch.currentHand.rollNumber === 0) {
						this.cup.showDiceInCup();
						this.diceHand.clearDiceOffScreen();
					} 
				}
			}
		}
	}

	sceneRestarting = false;
	sceneNeedsToReload = true;

	calcDimensions = (config) => {
		this.config = config;
		this.landscape = false; //this.config.width > this.config.height;

		this.xAspectDiff = this.config.width / 480;
		this.yAspectDiff = this.config.height / 852;

		this.scaleFactor = 2;
		this.assetScaleFactor = this.config.width / 640;
		this.oldAssetScaleFactor = (480 / 640) * this.scaleFactor;

		this.diceOldFullRes = 316;
		this.diceFullRes = 226;
		this.diceResRatio = this.diceFullRes / this.diceOldFullRes;
		this.diceTargetSize = this.landscape ? 95 : 226;
		this.diceBigScale = this.diceTargetSize / this.diceFullRes;
		this.diceActualWidth = this.diceBigScale * this.diceFullRes;
		this.diceGridPad = this.diceActualWidth * 0.015;
		this.diceTop = this.adjustY(852) * 0.25;
		if (!this.landscape) this.diceTop -= 10 * this.scaleFactor;
		this.diceTop += this.pushDownAmount;
		this.diceLeft = config.width / 2 - (this.diceActualWidth + this.diceGridPad);
		this.highlightScale = this.diceBigScale * 1.02 * 2 * this.diceResRatio; // 0.71;

		this.diceEndScale = 0.75 * (100 / 256) * 1.1;
		this.diceEndScale *= 2;
		this.dice2DSmallScale = ((1.15 * this.diceEndScale) / 2) * (this.diceOldFullRes / this.diceFullRes);

		this.aimPoint = { x: config.width / 2, y: config.height * 0.29 };
		this.farthestLaunchPoint = { x: 0, y: config.height };

		this.handBannerPosition = 233;//99 * 2; // this.adjustY(99);
		this.defaultButtonWidth = 130 * 2;
	};

	@observable gameState = { state: 'idle' };
	@observable diceStatus = 'resolved';

	_handPointer;
	set handPointer(anim) {
		if (this._handPointer) {
			this._handPointer.destroy();
		}
		this._handPointer = anim;
	}
	get handPointer() {
		return this._handPointer;
	}

	@computed get readyToRoll() {
		return this.diceStatus === 'resolved';
	}

	adjustX(oldX) {
		return oldX * this.xAspectDiff;
	}
	adjustY(oldY) {
		return oldY * this.scaleFactor; // this.yAspectDiff;
	}

	clearOtherStuff() {
		if (this.handBannerBack) this.handBannerBack.destroy();
		if (this.handBanner) this.handBanner.destroy();
		if (this.handHelp) this.handHelp.destroy();
	}
	clearMessages() {
		this.cup.hideCupSwirl();
		this.ui.hideTutorialBanner();
		this.ui.clearAvaPanel();
		if(this.popper)		this.popper.hide();

		if (!store.tutorialMode) {
			if (this.goalArrowTween != null) this.goalArrowTween.stop();
			if (this.goalArrowTween2 != null) this.goalArrowTween2.stop();
			this.goalArrowTween = null;
			this.goalArrowTween2 = null;
		}
		if (this.zoomerContainer != null) {
			this.zoomerContainer.destroy();
			this.zoomerContainer = null;
		}

		this.scoreCardTweens.forEach((el) => el.stop());
		this.scoreCardElements.forEach((el) => {
			if(el)
				el.destroy()
		});
		this.scoreCardHands.forEach((el) => el.destroy());
		this.scoreCardOpponentHands.forEach((el) => el.destroy());

		this.scoreCardBrownCirclePointsHands.forEach((el) => el.destroy());
		this.scoreCardBrownCirclePointsOpponentHands.forEach((el) => el.destroy());

		this.scoreCardElements = [];
		this.scoreCardHands = [];
		this.scoreCardOpponentHands = [];
		this.scoreCardBrownCirclePointsHands = [];
		this.scoreCardBrownCirclePointsOpponentHands = [];
		this.scoreCardTweens = [];
	}

	startThrow = (pointer) => {
		this.readyToLaunch = false;
		this.clearMessages();
		this.ui.showSettingsButton(false)

		if(pointer !== 'popper')
			this.diceHand.sendDiceToCup(false);

		if(!store.pokerRush) {
			var heldIndexes = [];
			if (store.activeMatch.currentHand) {
				//TODO: Stop duplicating the source of truth with the dice.
				this.diceHand.dice.forEach((d, i) => {
					store.activeMatch.currentHand.dice[i].held = d.locked; //!store.activeMatch.currentHand.dice[i].held;
					if (d.locked) {
						heldIndexes.push(i);
					}
				});
			}
		}

		if(!store.pokerRush) {
			this.diceReceived = false;
			// comm.RollDice(heldIndexes);
			//TODO: use the promise from this function to trigger the fact that dice have been received.
			store.activeMatch.currentHand.roll();
		} else 
			this.diceReceived = true;
	};
	allDiceResolved = () => {
		const m = this;
		m.gameState.state = 'idle';
		m.diceStatus = 'resolved';

		// showBigWinBanner();
		if (store.activeMatch.currentHand.rollsRemaining === 0 || store.activeMatch.currentHand.best) {
			m.ui.showBigWinBanner();
			gameSetTimeout(m.ui.showPlayHandButton, 1500 - 700);
			if(store.activeMatch.currentHand.match.length > 0)
				store.pulsePaylineValue = store.activeMatch.currentHand.rollNumber;
		} else {
			this.ui.showSettingsButton(true)
			if(/* !store.isProd && */ !store.tutorialMode && store.custom.usePopper)	{
				m.popper.gotoNextRoll();
				if (store.activeMatch.currentHand.rollNumber > 0) {
					m.ui.showSelectDiceMsg();
					m.ui.showZoomButton();
				}
			} else 	m.cup.returnCup();
		}
	}

	nextHand() {
		var handNumber = store.activeMatch.handNumber;
		store.activeMatch.nextHand().then(() => {
			this.ui.showScorecard(handNumber, false);
		});
	}

	stopGame = () => {
		this.showCupDebugInfo = false;
		if (this.cup) {
			this.cup.hideCup();
			this.clearMessages();
			this.clearOtherStuff();
		}
		window.gameTimeouts.forEach((t) => clearTimeout(t));
		window.gameTimeouts = [];

		this.scene.scene.sleep();
		if(this.diceInstances)			this.diceInstances.clear();
		if(this.handNameInstances)		this.handNameInstances.clear();
	};

	startGame = () => {
		let newGame = (!store.activeMatch.hands || store.activeMatch.hands.length === 1) 
			&& store.activeMatch.handNumber === 1 
			&& store.activeMatch.currentHand.rollNumber === 0
			&& !store.tutorialMode
		if(newGame) {
			integration.postEvent('match_start_first', 'gameplay', 1, true)
			integration.postEvent('match_start', 'gameplay', store.activeMatch.matchId)
		}
		this.continueStartGame();
	}
	continueStartGame = () => {
		this.showCupDebugInfo = false;
		//store.skillzHearts = !!store.skillzTourData ? ~~store.skillzTourData.numOfHearts : 2;
		store.skillzHearts = 0;

		if (this.sceneRestarting) {
			this.scene.scene.restart();
		}

		if (this.createScene) {
			//temporary patch - added more time
			// setTimeout(this.createScene, 500);
			this.createScene();
		} else {
			setTimeout(this.startGame, 500);
			return;
		}
	};

	startFTUE = () => {
		history.push('/game/intro/play');
	}
	
	resetToWaiting = () => {
		this.stopGame();
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve(this);
			}, 500);
		});
	};

	onCreateComplete = () => {
		console.log('START GAME CALLED');
		store.skillzTimeTicking = true;

		this.cup.hideCup();
		if(!store.pokerRush) {
			store.activeMatch.status = 0;
			this.addCurrentHandObserver();
		}
		this.gamesStarted++;
		this.ui.startMatch();
		store.modal = '';
	};

	addCurrentHandObserver() {
		if (!store.activeMatch.currentHand) return;
		if (this.currentHandObserver != null) this.currentHandObserver();
			const disposer3 = observe(store.activeMatch.currentHand, (change) => {
			if (change.name === 'rollNumber') {
				this.diceReceived = true;
			}
		});
		this.currentHandObserver = disposer3;
	}

	updateDeviceNotificationStatus () {
		if(store.deviceNotificationStatusUpdated === true)
			return;

		if(store.deviceNotificationsEnabled === false)
			store.changeSetting('notifications', false)

		store.deviceNotificationStatusUpdated = true;
	}
	showNotificationsPopup() {
		const now = Date.now();
		const last = ~~localStorage.getItem('notificationsPopupLastShown');
		const timeToShow = now - last > 7 * 24 *60*60*1000	// 7 days
		if(timeToShow) {
			this.updateDeviceNotificationStatus();
			gameSetTimeout(() => {
				if(!store.settings.notifications) 
					store.modal = 'turnOnNotifications';
			}, 500);
			window.setPersistentStorage('notificationsPopupLastShown', now);
		}
	}

	showInterstitialVideo() {
		return false;
		/*if(store.hasPurchasedIAP === 'true' || !store.videoAdIsLoaded)
			return false;

		store.botVideo = false;

		if (store.firstLaunchUtcSecs === '') 
			return false;
		var d = Date.now() / 1000;
		var f = store.firstLaunchUtcSecs === '' ? '1601945733' : store.firstLaunchUtcSecs;
		console.log(':::::::::::::::::::: DATE NOW: ' + d + ' first Launch UTC: ' + f);
		var elapsedSecs = d - parseInt(f);
		var elapsedMins = elapsedSecs / 60;
		var elapsedHours = elapsedSecs / (60 * 60);
		console.log('ELAPSED HOURS: ' + elapsedHours + ' MINS ' + elapsedMins + ' ELAPSED SECS ' + elapsedSecs);

		let minMins = store.firstInterstitialDelay; // 24 * 60;
		if (elapsedMins < minMins || store.user.level < 4 || store.hasPurchasedIAP === 'true') 
			return false;

		if (store.enableAds) {
			let timeToShow = false;
			let freq = (store.interstitialTestActive && (store.remoteConfig_interstitial_test === 'OPTIONB' || store.remoteConfig_interstitial_test === 'OPTIONC')) ? 2 : 3;

			timeToShow = (store.activeMatch.handNumber === 7 || store.activeMatch.handNumber === 4 || store.activeMatch.handNumber === 1);

			if (!timeToShow) 
				return false;
			let showVideo = store.videoAdIsLoaded /* && store.turnsThisSession > 0 */ /* && store.turnsSinceLastAdView >= freq * /; // && store.user.level >= 4;
			if (showVideo) {
				store.botVideo = true;	//make turn off ads appear

				if (window.location.port === '3000' || window.location.hash === '#dev') 
					store.modal = 'turnoffads';
				else 
					window.WrapperApp.postMessage('show-video');
				return true;
			}
		}
		return false;*/
	}
	showProductStore(showCoins = false) {
		/* store.modal = 'store';
		store.getAndShowProductStore(showCoins); */
	}

	playAudio(name, del=0) {
		if (store.settings.sound && !store.isSkillzInited) {
			console.log(' \t\t PLAY SOUND', name)
			//if (window.location.port === '3000' || window.location.hash === '#dev') {
				if(del===0)
					window.manager.playAudioSprite(name);
				else 
					setTimeout(window.manager.playAudioSprite, del, name);
			/* } else if (window.WrapperApp) {
				if (name === 'bumper' && store.settings.vibration) name = 'bumperHaptic';

				window.WrapperApp.postMessage('play-sfx?name=' + name + '&del=' + del);

				// let rawJson = '{"cmd":"sfx_play","param":"'+name+'"}';
				// window.WrapperApp.postMessage(rawJson);
			} */
		}
	}
	playAudioSprite(name) {
		if (this.scene && this.scene.sound) this.scene.sound.playAudioSprite('sfx', name);
	}
	playHaptic(name = 'haptic_mediumImpact', sfxName = 'none') {
		if (store.settings.vibration) {
			if (window.location.port === '3000' || window.location.hash === '#dev') {
				console.log('running dev skipping haptic');
				if (sfxName !== 'none') window.manager.playAudio(sfxName);
			} else if (window.WrapperApp) {
				if (!store.settings.sound) sfxName = 'none';
				window.WrapperApp.postMessage('play-haptic?name=' + name + '&sfxName=' + sfxName);
			}
		} else {
			if (sfxName !== 'none') window.manager.playAudio(sfxName);
		}
	}
	
	region = 'n/a';
	disallowedRegion = 'WA';

	//phaser sideloading code
	get_filesize(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
									 //  to get only the header
		xhr.onreadystatechange = function() {
			if (this.readyState === this.DONE) {
				callback(parseInt(xhr.getResponseHeader("Content-Length")));
			}
		};
		xhr.send();
	}
	sideLoadSpriteSheet (keyName, asset, obj) {
		let showSize = false;
		if(!this.scene.textures.exists(keyName)) {
			if(showSize) {
				window.manager.get_filesize(asset, function(size) {
					console.log('SIDELOADING SPRITESHEET: '+asset+'\t\t SIZE: '+size);
					window.manager.scene.load.once('complete', window.manager.processSideLoading);
					window.manager.scene.load.spritesheet(keyName, asset, obj);
					window.manager.scene.load.start();
				});
			} else {
				console.log('SIDELOADING SPRITESHEET: '+keyName);
				// store.debug = 'SIDELOADING: '+keyName;
				window.manager.scene.load.once('complete', window.manager.processSideLoading);
				window.manager.scene.load.spritesheet(keyName, asset, obj);
				window.manager.scene.load.start();
			}
		}
	}
	sideLoadImage (keyName, asset) {
		let showSize = false;
		if(!window.manager.scene.textures.exists(keyName)) {
			if(showSize) {
				window.manager.get_filesize(asset, function(size) {
					console.log('SIDELOADING IMAGE: '+asset+'\t\t SIZE: '+size);
					window.manager.scene.load.once('complete', window.manager.processSideLoading);
					window.manager.scene.load.image(keyName, asset);
					window.manager.scene.load.start();
				});
			} else {
				console.log("SIDELOADING IMAGE: "+asset);
				// store.debug = 'SIDELOADING: '+keyName;
				window.manager.scene.load.once('complete', window.manager.processSideLoading);
				window.manager.scene.load.image(keyName, asset);
				window.manager.scene.load.start();
			}
		}
	}
	processSideLoading() {
		if(store.phaserSideLoadImages.length > 0 || store.phaserSideLoadSpriteSheets.length > 0) {
			store.phaserSideLoading = true;
			if(store.phaserSideLoadImages.length > 0) {
				var item = store.phaserSideLoadImages.pop();
				window.manager.sideLoadImage(item.keyName, item.asset);
				return;
			}
			if(store.phaserSideLoadSpriteSheets.length > 0) {
				var item = store.phaserSideLoadSpriteSheets.pop();
				window.manager.sideLoadSpriteSheet(item.keyName, item.asset, item.obj);
				return;
			}
		} else {
			store.phaserSideLoading = false;
			// store.debug = 'SIDELOADING COMPLETE';
		}
	}
	startSideLoading() {
		if(store.phaserSideLoading)
			return;
		if(store.phaserSideLoadImages.length > 0 || store.phaserSideLoadSpriteSheets.length > 0) {
			store.phaserSideLoading = true;
			this.processSideLoading();
		}
	}
}